import React from 'react';
import ReactHtmlParser, { processNodes, convertNodeToElement, htmlparser2 } from 'react-html-parser';
import {replaceDbValuesForTable} from '../utils/utils';
import TabsRenderProp from './TabsRenderProp';
const Fragment = React.Fragment;

const Summary = ({summaryHeader, summaryContent} ) => {
  return (
    <TabsRenderProp 
    header={() => (
      <React.Fragment>{summaryHeader}</React.Fragment>
    )} 
    content={() => (
      <React.Fragment>
        {ReactHtmlParser(summaryContent)}
      </React.Fragment>
    )}
    />
  )
}

export default Summary;



// WEBPACK FOOTER //
// ./src/components/Summary.js